module.exports = __webpack_public_path__ + "static/img/200266.75eb3a52.png";